import { render, staticRenderFns } from "./problem-list.vue?vue&type=template&id=4dce8887&scoped=true&"
import script from "./problem-list.vue?vue&type=script&lang=js&"
export * from "./problem-list.vue?vue&type=script&lang=js&"
import style0 from "./problem-list.vue?vue&type=style&index=0&id=4dce8887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce8887",
  null
  
)

export default component.exports